import { useContext } from 'react';
import { Modal, Text, Button } from '@mantine/core';
import { MenuMappingContext } from '../MenuMapping';

interface ActionConfirmationModalProps {
  close: () => void;
  opened: boolean;
  action: string;
}

export default function ActionConfirmationModal({
  close,
  opened,
  action,
}: ActionConfirmationModalProps) {
  const { handleAutoMap } = useContext(MenuMappingContext);

  const onConfirm = () => {
    switch (action) {
      case 'Map all unmapped items':
        handleAutoMap({ unmapAll: false, forceMap: false });
        break;
      case 'Map all items':
        handleAutoMap({ unmapAll: false, forceMap: true });
        break;
      case 'Unmap all items':
        handleAutoMap({ unmapAll: true, forceMap: false });
        break;
      default:
        break;
    }
    close();
  };

  return (
    <Modal opened={opened} onClose={close} title={action} size="md">
      <Text variant="body-sm">Are you sure you want to {action.toLowerCase()}?</Text>
      <Button onClick={onConfirm} fullWidth mt="md">
        Confirm
      </Button>
      <Button onClick={close} fullWidth mt="xs" variant="outline">
        Cancel
      </Button>
    </Modal>
  );
}
